/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { CircularProgress, makeStyles } from "@material-ui/core";

export const useAppLoadingIndicatorStyles = makeStyles({
  appLoadingIndicator: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

export const AppLoadingIndicator = () => {
  const classes = useAppLoadingIndicatorStyles();
  return (
    <div
      className={classes.appLoadingIndicator}
    >
      <CircularProgress size={80} color="primary" />
    </div>
  )
}
